export default __webpack_public_path__ + "static/media/angular.e6ed573f.svg";